export const script = (
  media: string,
  themes: Array<string>,
  storageKeys: { colorMode: string; colorScheme: string },
  defaultColorMode: string,
  defaultColorScheme: string,
  enableSystem: boolean,
) => {
  const el = document.documentElement;

  function updateDOM(theme: string) {
    console.log("theme: ", theme);
    el.classList.remove(...themes);
    el.classList.add(theme);
  }

  function getSystemTheme() {
    return window.matchMedia(media).matches ? "dark" : "light";
  }

  try {
    const themeName =
      localStorage.getItem(storageKeys.colorMode) || defaultColorMode;
    const isSystem = enableSystem && themeName === "system";
    const theme = isSystem ? getSystemTheme() : themeName;
    updateDOM(defaultColorScheme + theme);
  } catch (e) {
    //
    console.log("Something went wrong, please referr to the error below");
    console.log("Error: ", e);
  }
};
